import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import Portal from './portal';
import {connectElements} from './utils';

export default class ReactConnectElements extends PureComponent {
    static propTypes = {
        elements: PropTypes.array.isRequired,
        overlay: PropTypes.number,
        selector: PropTypes.string.isRequired,
        // strokeWidth: PropTypes.number,
        color: PropTypes.string,
        off: PropTypes.bool,
        animations: PropTypes.object    ,
    };

    static defaultProps = {
        overlay: 0,
        strokeWidth: 5,
        color: '#666',
    };

    state = {
        querySelector: 'body',
        animations: this.props.animations || [],
    };

    componentDidMount() {
        this.checkSelector();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        // if (prevProps.off !== this.props.off) {

        this.checkSelector();
        // }
    }

    checkSelector = () => {
        if (document.querySelector(this.props.selector)) {
            this.setState({querySelector: this.props.selector}, () =>
                this.connectAll()
            );
        }
    };

    connectAll = () => {
        const {elements} = this.props;

        elements.map((element, index) => {
            const start = document.querySelector(element.from);
            const end = document.querySelector(element.to);
            const path = document.querySelector(`#path${index + 1}`);
            // console.log(this.props.animations, 'before draw path');
            return connectElements(this.svgContainer, this.svg, path, start, end, this.props.animations,index);
        });
    };

    getProgress(index) {
        console.log(this.props.animations, index, 'bla');
        console.log(this.state.animations)
        //
        // const values =     Object.values(this.props.animations)

        // console.log(values)
        // if(this.props.animations[index]){
        //     console.log(this.props.animations[index].progress, 'progress');
        //     return this.props.animations[index].progress;
        // }
        // console.log(this.state.animations.find(i => i.index = index), 'progress');

        // //
        //  console.log(this.props.animations.filter(i=>i.index === index), "this");
        const el=  this.state.animations.filter(i => i.index === index )
        //  console.log(el[0], 'el');
         return el[0] ? el[0].progress*100 : 0
        // return 200;
    }

    render() {
        const {elements, overlay, strokeWidth, color} = this.props;

        return (
            this.state.querySelector && (
                <Portal query={this.state.querySelector}>
                    <div
                        id="react-connect-elements-container"
                        style={{zIndex: overlay, position: 'absolute'}}
                        ref={svg => {
                            this.svgContainer = svg;
                        }}
                    >
                        <svg
                            width="0"
                            height="0"
                            ref={svg => {
                                this.svg = svg;
                            }}
                        >
                            {elements.map((element, index) => (
                                <path
                                    key={`${element.from}-${element.to}`}
                                    id={`path${index + 1}`}
                                    d="M0 0"
                                    stroke={element.color || color}
                                    fill="none"

                                    strokeWidth={`${strokeWidth}px`}
                                />
                            ))}
                        </svg>
                    </div>
                </Portal>
            )
        );
    }
}
